export default __webpack_public_path__ + "static/media/2.5c3f3f1b.png";